import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import Typography from '@material-ui/core/Typography';
import VisibilityIcon from '@material-ui/icons/Visibility';
import StickerIcon from '@material-ui/icons/CropFree';
import environment from '../environments';
import { NavLink } from 'react-router-dom';
import { observer } from "mobx-react";

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing.unit * 3
  },
  icon: {
    fontSize: "0.8rem",
    verticalAlign: "-3px"
  }
});

class Stickers extends Component {  

  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
  }

  componentDidMount() {
    this.props.stickerStore.getStickerList();
  }
  
  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.props.stickerStore.stickerList.length > 0 ? (
        <List component="nav" className={classes.root}>
        {this.props.stickerStore.stickerList.map((item, index) =>
          <div key={index}>
          <ListItem button key={index} component={NavLink} to={"/stickers/" + item.uuid}>
            <Avatar src={environment.CDN_HOST + "/" + item.icon_key} />
            <ListItemText primary={item.title || "Kein Beschreibung"} disableTypography={true} secondary={
              <React.Fragment>
                <Grid container
                  direction="row"
                  justify="flex-start"
                  alignItems="center"
                  style={{height: "20px"}}>

                  <Grid container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    style={{height: "20px"}}>
                      <Grid item style={{height: "20px"}}>
                        <VisibilityIcon fontSize="small" style={{marginRight: "3px"}} />
                      </Grid>
                      <Grid item style={{height: "20px", marginRight: "10px"}}>
                        {item.scans}
                      </Grid>
                      <Grid item style={{height: "20px"}}>
                        <StickerIcon fontSize="small" style={{marginRight: "3px"}} />
                      </Grid>
                      <Grid item style={{height: "20px"}}>
                        {item.identifier}
                      </Grid>
                  </Grid>
                </Grid>
              </React.Fragment>
            }/>

            {item.photo_key && (
              <Avatar src={environment.CDN_HOST + "/" + item.photo_key} style={{ borderRadius: 0 }} />
            )}
            
          </ListItem>
          <Divider />
          </div>
        )}
        </List> ) : (
          <Paper className={classes.paper}>
            <Typography variant="h5">
              Keine Sticker vorhanden
            </Typography>
            <Typography component="p">
              Sie haben noch keine Sticker zu Ihrem Profil hinzugefügt.
            </Typography>
            <hr />
            <Typography component="p" style={{marginBottom: "15px"}}>
                Um einen Sticker zu aktivieren, folgen Sie diesen Anweisungen:
            </Typography>
              <ol>
                <li>
                  Drücken Sie auf das <strong>Kamera-Symbol</strong> <PhotoCameraIcon className={classes.icon} /> in der oberen rechten Ecke
                </li>
                <li>
                  Erlauben Sie QRSticker den <strong>Zugriff auf die Kamera</strong> Ihres Smartphones
                </li>
                <li>
                  <strong>Scannen Sie einen Sticker</strong> aus dem Sortiment von QRSticker
                </li>
                <li>
                  Ihr Sticker ist nun Ihrem Profil zugeordnet. <strong>Sie können mit der Bearbeitung beginnen</strong>
                </li>  
              </ol>
          </Paper>
        )}
        
    </div>
    );
  }
}

export default withStyles(styles)(observer(Stickers));
